<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-12 14:07:01
--> 
<template>
  <div>
    <staffOfficial></staffOfficial>
  </div>
</template> 
 
<script>
import staffOfficial from './staffGrade.vue'
export default {
  components: {
    staffOfficial
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>